// Medical aid tax credits for 2026-2027 tax year
export const MEDICAL_AID_CREDITS_2026_27 = {
  mainMember: 376,        // R376 per month for main member
  firstDependent: 376,    // R376 per month for first dependent
  additionalDependent: 254 // R254 per month for each additional dependent
};

// Annual amounts (multiply monthly by 12)
export const ANNUAL_MEDICAL_AID_CREDITS_2026_27 = {
  mainMember: MEDICAL_AID_CREDITS_2026_27.mainMember * 12,           // R4,512
  firstDependent: MEDICAL_AID_CREDITS_2026_27.firstDependent * 12,   // R4,512
  additionalDependent: MEDICAL_AID_CREDITS_2026_27.additionalDependent * 12 // R3,048
};
